module.exports = __webpack_public_path__ + "static/media/film-akcja.4b05a85f.mp4";